import { BaseHandlerOption } from "@tt-app/models/exercise";
import { MainLogger } from "@tt-app/utils/internal/logger";

export abstract class BaseHandler {
  // --------------------------------------------------------------------------
  //  Attributes
  // --------------------------------------------------------------------------
  protected _debugMode: boolean;

  // --------------------------------------------------------------------------
  //  Initialisation
  // --------------------------------------------------------------------------
  constructor(options: BaseHandlerOption = {}) {
    this._debugMode = options.debugMode || false;
  }

  // --------------------------------------------------------------------------
  //  Methods: internale
  // --------------------------------------------------------------------------
  protected _info(msg: string) {
    if (process.env.NODE_ENV !== "production") {
      MainLogger.info(`%c${msg}`, "color: cyan;");
    }
  }
  protected _debug(msg: string) {
    if (process.env.NODE_ENV !== "production" && this._debugMode) {
      MainLogger.debug(`%c${msg}`, "color: green;");
    }
  }
  protected _warn(msg: string) {
    MainLogger.warn(`%c${msg}`, "color: yellow;");
  }
}
